import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { WEB_CONFIG } from "./web-config";

/**
 * Whether a path opens onto the story viewer rather than a page: the story
 * player, the builder's hotlink preview, a QR code that links straight to a
 * story, or a map based division. These get the dark canvas loader instead of
 * the page shimmer, and a canvas colored `<body>`.
 *
 * The server applies the same rule when it renders the shell
 * (`data-viewer` in `render.ts`), so the two must stay in step.
 */
export function isViewerRoute(pathname: string) {
  const isGame = /\/gm_/i.test(pathname) || /_hotlink/i.test(pathname);
  const isStoryQR =
    !!WEB_CONFIG.QR_MATCH?.STORY_ID &&
    pathname === `/${WEB_CONFIG.QR_MATCH.ID}`;
  const isMap = !!WEB_CONFIG.DIVISION_INFO?.mapBased;

  return isGame || isStoryQR || isMap;
}

/**
 * Keeps `body[data-viewer]` in step with the route after client side
 * navigation. The server sets it for the first paint, so the viewer's black
 * canvas is what shows while the bundle loads, not the theme background.
 */
export const ViewerRouteBodyAttribute: FC = () => {
  const { pathname } = useLocation();
  const viewer = isViewerRoute(pathname);

  useEffect(() => {
    if (viewer) document.body.setAttribute("data-viewer", "");
    else document.body.removeAttribute("data-viewer");
  }, [viewer]);

  return null;
};
